module.exports = __webpack_public_path__ + "media/images/searching-97eee42c93aa79956537ab08d90a7555.png";